import script from "./ModalSyosiList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalSyosiList.vue?vue&type=script&setup=true&lang=ts"

import "./ModalSyosiList.vue?vue&type=style&index=0&id=337cf725&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-337cf725"]])

export default __exports__